var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72745 14H14.7262C16.0555 14 16.8841 12.6253 16.2195 11.5305L9.72006 0.821108C9.05545 -0.273703 7.39823 -0.273703 6.73362 0.821108L0.234229 11.5305C-0.430383 12.6253 0.398225 14 1.72745 14ZM8.22684 8.23784C7.75212 8.23784 7.36371 7.86741 7.36371 7.41467V5.76834C7.36371 5.3156 7.75212 4.94517 8.22684 4.94517C8.70157 4.94517 9.08998 5.3156 9.08998 5.76834V7.41467C9.08998 7.86741 8.70157 8.23784 8.22684 8.23784ZM9.08998 11.5305H7.36371V9.88417H9.08998V11.5305Z",
    fill: "#EE7700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.1ab31224ef18f7d763e0aae1de40f511.svg";
export { ForwardRef as ReactComponent };